import React from 'react';
import { Typography } from 'antd';

const { Text } = Typography;

export default function NAText(): JSX.Element {
  return <Text type="secondary">N/A</Text>;
}
